// extracted by mini-css-extract-plugin
export var statItem = "_hu-1";
export var statsRow = "_hu-0";